import { match, P } from "ts-pattern"
import { NavStep } from "../../app-core/v3/_common/nav-step"
import { StepState } from "./Step/Step"

export const tabState = (
    completed: boolean,
    activeIndex: number,
    currentIndex: number,
    canGoto: boolean,
): StepState => {
    const isActive = currentIndex == activeIndex

    return match<[boolean, boolean, boolean], StepState>([isActive, completed, canGoto])
        .with([P.boolean, P.boolean, false], () => "disabled")
        .with([true, true, P.boolean], () => "active-completed")
        .with([true, false, P.boolean], () => "active")
        .with([false, true, P.boolean], () => "completed")
        .with([false, false, P.boolean], () => "disabled")
        .exhaustive()
}

export const findActiveStep = <T extends string>(steps: NavStep<T>[], activeStepId: T): NavStep<T> =>
    steps.find((x) => x.id == activeStepId)!
